import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import {
  profileQueryKeys,
  useProfileMutationFeedback,
} from './useProfileMutationFeedback';

const upsertEmergencyContactMutation = graphql(/* GraphQL */ `
  mutation upsertEmergencyContact($input: UserEmergencyContactInput!) {
    upsertEmergencyContact(input: $input)
  }
`);

export type UserEmergencyContactInput = {
  contactId: number;
  userId?: string;
  fullName: string;
  phone: string;
};

const useUpsertEmergencyContact = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const userId = user?.sub ?? '';
  const feedback = useProfileMutationFeedback({
    successMessage: 'Emergency contact saved',
    queryKeys: [profileQueryKeys.emergencyContacts(userId)],
  });

  return useMutation({
    mutationFn: async (input: UserEmergencyContactInput) => {
      if (!isAuthenticated) {
        throw new Error(
          'User must be authenticated to upsert emergency contact',
        );
      }
      return graphqlRequest(
        upsertEmergencyContactMutation,
        { input },
        getAccessTokenSilently,
      );
    },
    ...feedback,
  });
};

export default useUpsertEmergencyContact;
